export const FETCH_ANNOUNCEMENTS_REQUEST = 'FETCH_ANNOUNCEMENTS_REQUEST';
export const FETCH_ANNOUNCEMENTS_SUCCESS = 'FETCH_ANNOUNCEMENTS_SUCCESS';
export const FETCH_ANNOUNCEMENTS_FAILURE = 'FETCH_ANNOUNCEMENTS_FAILURE';

export const FETCH_ANNOUNCEMENTS_NEXT_REQUEST = 'FETCH_ANNOUNCEMENTS_NEXT_REQUEST';
export const FETCH_ANNOUNCEMENTS_NEXT_SUCCESS = 'FETCH_ANNOUNCEMENTS_NEXT_SUCCESS';
export const FETCH_ANNOUNCEMENTS_NEXT_FAILURE = 'FETCH_ANNOUNCEMENTS_NEXT_FAILURE';

export const FETCH_ANNOUNCEMENT_REQUEST = 'FETCH_ANNOUNCEMENT_REQUEST';
export const FETCH_ANNOUNCEMENT_SUCCESS = 'FETCH_ANNOUNCEMENT_SUCCESS';
export const FETCH_ANNOUNCEMENT_FAILURE = 'FETCH_ANNOUNCEMENT_FAILURE';

export const FETCH_ANNOUNCEMENT_WIZARD_DATA_REQUEST = 'FETCH_ANNOUNCEMENT_WIZARD_DATA_REQUEST';
export const FETCH_ANNOUNCEMENT_WIZARD_DATA_SUCCESS = 'FETCH_ANNOUNCEMENT_WIZARD_DATA_SUCCESS';
export const FETCH_ANNOUNCEMENT_WIZARD_DATA_FAILURE = 'FETCH_ANNOUNCEMENT_WIZARD_DATA_FAILURE';

export const ADD_ANNOUNCEMENT_REQUEST = 'ADD_ANNOUNCEMENT_REQUEST';
export const ADD_ANNOUNCEMENT_SUCCESS = 'ADD_ANNOUNCEMENT_SUCCESS';
export const ADD_ANNOUNCEMENT_FAILURE = 'ADD_ANNOUNCEMENT_FAILURE';

export const UPDATE_ANNOUNCEMENT_REQUEST = 'UPDATE_ANNOUNCEMENT_REQUEST';
export const UPDATE_ANNOUNCEMENT_SUCCESS = 'UPDATE_ANNOUNCEMENT_SUCCESS';
export const UPDATE_ANNOUNCEMENT_FAILURE = 'UPDATE_ANNOUNCEMENT_FAILURE';

export const DELETE_ANNOUNCEMENT_REQUEST = 'DELETE_ANNOUNCEMENT_REQUEST';
export const DELETE_ANNOUNCEMENT_SUCCESS = 'DELETE_ANNOUNCEMENT_SUCCESS';
export const DELETE_ANNOUNCEMENT_FAILURE = 'DELETE_ANNOUNCEMENT_FAILURE';

export const RESET_ANNOUNCEMENT_DATA = 'RESET_ANNOUNCEMENT_DATA';

export const FETCH_ANNOUNCEMENTS_FEED_REQUEST = 'FETCH_ANNOUNCEMENTS_FEED_REQUEST';
export const FETCH_ANNOUNCEMENTS_FEED_SUCCESS = 'FETCH_ANNOUNCEMENTS_FEED_SUCCESS';
export const FETCH_ANNOUNCEMENTS_FEED_FAILURE = 'FETCH_ANNOUNCEMENTS_FEED_FAILURE';

export const OPEN_ANNOUNCEMENTS_SIDEPANEL = 'OPEN_ANNOUNCEMENTS_SIDEPANEL';
export const CLOSE_ANNOUNCEMENTS_SIDEPANEL = 'CLOSE_ANNOUNCEMENTS_SIDEPANEL';

export const FETCH_BANNER_ANNOUNCEMENT_REQUEST = 'FETCH_BANNER_ANNOUNCEMENT_REQUEST';
export const FETCH_BANNER_ANNOUNCEMENT_SUCCESS = 'FETCH_BANNER_ANNOUNCEMENT_SUCCESS';
export const FETCH_BANNER_ANNOUNCEMENT_FAILURE = 'FETCH_BANNER_ANNOUNCEMENT_FAILURE';
